import { Module } from 'vuex'
import { RootState } from '@ps/types/store'
import { UploaderState } from '../../types/store/uploader.type'
import _ from 'lodash'
import Vue from 'vue'

const namespaced = true

const getInitResourceList = () => {
  return {
    image: [],
    audio: [],
    video: [],
    zip: [],
    xlz: [],
    others: [],
  }
}

const state: UploaderState = {
  dialog: {
    visible: false,
    appendToBody: true,
  },
  // @ts-ignore
  resourceList: getInitResourceList(),
}

const permission: Module<UploaderState, RootState> = {
  namespaced,
  state,

  mutations: {
    openDialog(state) {
      state.dialog.visible = true
    },

    closeDialog(state) {
      state.dialog.visible = false
    },

    updateFileList(state, val) {
      console.log(val)
      _.each(val, (item, key) => {
        item.forEach((resource) => {
          Vue.set(resource, 'timestamp', Date.now())
        })
        // state.resourceList[key] = [...state.resourceList[key], ...item]
        Vue.set(state.resourceList, key, [...state.resourceList[key], ...item])
      })
    },

    resetFileList(state) {
      state.resourceList = getInitResourceList()
    },
  },

  actions: {},
}

export default permission
